import React from 'react';
import { Outlet } from 'react-router-dom';

import WpSessionDropdown from '@dashboard/components/SessionDropdown';
import { WhiteWaypointLogo } from '@dashboard/components/WaypointLogo';
import PlatformManager from '@dashboard/contexts/PlatformManager';
import { usePlatformQuery } from '@dashboard/generated/wp/authentication';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { AppBar, Box, Container, Toolbar } from '@mui/material';

const getPlatformApiPath = (platformId: string) => `/wp/platforms/${platformId}/graphql`;

export default function PlatformContextPageLayout(): JsxNode {
  const platformId = useCurrentPlatformId();
  const { data } = usePlatformQuery({ variables: { id: platformId } });

  const platform = data?.Platform;

  if (!platform) {
    return (
      <AppBar color="primary" position="static">
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <WhiteWaypointLogo />

            <Box maxWidth={512}>
              <WpSessionDropdown />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    );
  }

  const { id, apiHost } = platform;
  return (
    <PlatformManager uri={`${apiHost}${getPlatformApiPath(id)}`}>
      <Outlet />
    </PlatformManager>
  );
}
